import { Button, styled } from "@material-ui/core";
import styles from "./upload-button.module.scss";
import uploadIcon from "assets/images/upload-icon.svg";
import i18n from "i18n";

const UploadButton = ({ handleFileUpload, className }) => {

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
      });


    return (
        <div className={className ?? ""}>
            <Button
                className={styles["color-upload"]}
                component="label"
                role={undefined}
                tabIndex={-1}
                startIcon={
                    <picture>
                        <img src={uploadIcon} draggable={false} />
                    </picture>
                }
            >
                {i18n.t("import.file").toUpperCase()}
                <VisuallyHiddenInput
                    type="file"
                    accept=".xlsx,.ods"
                    onChange={handleFileUpload}
                    multiple
                />
            </Button>
        </div>
    );

}


export default UploadButton;
